import { Location } from '../dtos/location';
import { accessToken } from '../utils/helper';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';

interface LocationState {
  locationList:
    | { data: Location[]; total: number; totalPages: number }
    | { data: []; total: 0; totalPages: 0 };
  loading: boolean;
  error: string | null;
}

const initialState: LocationState = {
  locationList: { data: [], total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export const getAllLocationsTrigger = createAsyncThunk(
  'get/locations',
  async ({
    page,
    limit,
    search,
    sortOrder,
    sortField,
  }: {
    page?: number;
    limit?: number;
    search?: string;
    sortOrder?: string;
    sortField?: string;
  }) => {
    try {
      // Clean the sortField to remove any malformed characters - use snake_case to match iOS app
      const cleanSortField = sortField ? sortField.split(':')[0] : undefined;

      const queryParams = new URLSearchParams();
      if (page) queryParams.append('page', page.toString());
      if (limit) queryParams.append('limit', limit.toString());
      if (search) queryParams.append('search', search);
      if (sortOrder) queryParams.append('sortOrder', sortOrder);
      if (cleanSortField) queryParams.append('sortField', cleanSortField);

      const url = `/locations?${queryParams}`;
      console.log('🔍 [locationSlice] Final URL:', url);

      const response = await api.get(url, accessToken());
      return response.data;
    } catch (error) {
      console.log(error);
      return { data: [], totalPages: 0 };
    }
  },
);

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLocationsTrigger.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllLocationsTrigger.fulfilled, (state, action) => {
        state.loading = false;
        state.locationList = action.payload;
      })
      .addCase(getAllLocationsTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to get location';
      });
  },
});
export default locationSlice.reducer;
